import { funcPowerAutomate } from '@/plugins/axios';


export const postAgreementRequirement = (data) => {
  return funcPowerAutomate.post(`powerautomate/automations/direct/workflows/b164eaa084d34828899b64e501abd766/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=JXI-8nNHJlU2cPmCP7l993XrXXEDG638P-IjXkg_FY0`, data);
};



